import { useEffect, useState } from "react"
import { MultiSelect } from "primereact/multiselect"

//Appointments modules.
import { groupFilterTemplate } from "./utils"

//Styles
import myStyles from "../../styles/appointments/Appointments.module.css"
import { classNames } from "primereact/utils"

export default function AppointmentFilters({
  filterValues,
  onChangeFilterValues,
  services,
  loading,
}) {
  const [groupedFilters, setGroupFilters] = useState(groupFilterTemplate)

  useEffect(() => {
    let modifiedGroup = groupedFilters

    modifiedGroup[0].items = services.map((x) => {
      return { label: x, value: x }
    })
    setGroupFilters(modifiedGroup)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [services])

  const groupedItemTemplate = (option) => {
    return (
      <div className={myStyles.filterGroupLabel}>
        {option.label}
      </div>
    );
  };

  return (
    <>
      <MultiSelect
        className={classNames(myStyles.mainFilter, myStyles.filterItemBorder)}
        display="chip"
        value={filterValues}
        options={groupedFilters}
        onChange={(e) => {
          onChangeFilterValues(e.value)
        }}
        optionLabel="label"
        optionGroupLabel="label"
        optionGroupChildren="items"
        placeholder="Select Appointment Filters"
        optionGroupTemplate={groupedItemTemplate}
        disabled={loading}
      />
    </>
  )
}
